export const columnasMatchingJudicialList = [
    {
        key: 'NRO_EMBARGO',
        label: 'N° embargo',
        type: 'string',
        sorted: true,
    },
    {
        key: 'NRO_EXPEDIENTE',
        label: 'N° expediente',
        type: 'string',
        sorted: true,
    },
    {
        key: 'FECHA_ALTA',
        label: 'Fecha Alta Embargo',
        type: 'date',
        sorted: true,
        headerClassName: 'max-w-[50px]',
        cellClassName: 'max-w-[85px]'
    },
    {
        key: 'CUIJ',
        label: 'CUIJ',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[72px]',
        cellClassName: 'max-w-[62px]'
    },
    {
        key: 'CARATULA',
        label: 'Carátula de embargo',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[200px]',
        cellClassName: 'max-w-[190px]'
    },
    {
        key: 'JURISDICCION',
        label: 'Jurisdicción',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[65px]',
        cellClassName: 'max-w-[85px]'
    },
    {
        key: 'FUERO',
        label: 'Fuero',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[60px]',
        cellClassName: 'max-w-[60px]'
    },
    {
        key: 'JUZGADO',
        label: 'Juzgado',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[95px]',
        cellClassName: 'max-w-[85px]'
    },
    {
        key: 'IMPORTE',
        label: 'Importe',
        type: 'number',
        sortKey: 'currency',
        sorted: true,
    },
    {
        key: 'FECHA_DEBITO',
        label: 'Fecha de débito bancario',
        type: 'date',
        sorted: true,
        headerClassName: 'max-w-[50px]',
        cellClassName: 'max-w-[85px]'
    },
    {
        key: "PORC_MATCH_VALUE",
        label: "",
        type: "number",
        hidden: true
    },
    {
        key: 'PORC_MATCH',
        label: 'Coincidencia',
        type: 'component',
        sorted: true,
        sortKey: 'value',
        headerClassName: 'max-w-[90px]',
        cellClassName: 'max-w-[70px]'
    },
    {
        key: 'NRO_CARPETA_JUICIO',
        label: 'N° Juicio',
        type: 'string',
        sorted: true,
        headerClassName: 'max-w-[60px]',
        cellClassName: 'max-w-[90px]'
    },
    {
        key: 'GRUPO',
        label: 'Grupo',
        type: 'component',
        sorted: true,
        sortKey: 'value',
        headerClassName: 'max-w-[45px]',
        cellClassName: 'max-w-[85px]'
    },
    {
        key: "acciones",
        label: "",
        sorted: false,
        type: "component"
    },
    {
        key: "ESTADO_EMBARGO",
        label: "",
        type: "number",
        hidden: true
    },
    {
        key: "ESTADO_LEGALES",
        label: "",
        type: "string",
        hidden: true
    },
    {
        key: "ID_EMAIL",
        label: "",
        type: "number",
        hidden: true
    },
    {
        key: "ID_JUICIO",
        label: "",
        type: "number",
        hidden: true
    }
];